import { useEffect, useState } from "react";


export default function CurrentPackages({ data }) {

    const [allowableEventCount, setAllowableEventCount] = useState(0);
    const [allowableDemoCount, setAllowableDemoCount] = useState(0);
    const [activeEvents, setActiveEvents] = useState(0);
    const [activeDemos, setActiveDemos] = useState(0);
    const [packageName, setPackageName] = useState("");
    const [expiryOn, setExpiryOn] = useState("");
    const [percentage, setPercentage] = useState("0%");
    const [demoPercentage, setDemoPercentage] = useState("0%");
    const [isExpired, setIsExpired] = useState(false);

    const [allowableImageCount, setAllowableImageCount] = useState(0);
    const [imageCount, setImageCount] = useState(0);
    const [imagePercentage, setImagePercentage] = useState("0%");

    const [allowableVideoCount, setAllowableVideoCount] = useState(0);
    const [videoCount, setVideoCount] = useState(0);
    const [videoPercentage, setVideoPercentage] = useState("0%");

    useEffect(() => {
        if (data) {
            setAllowableEventCount(data.allowableEventCount);
            setAllowableDemoCount(data.allowableDemoCount);
            setPackageName(data.packageName);
            setExpiryOn(data.expiredOn);
            let activeCount = data.weddingCount + data.birthdayCount + data.ceremonyCount + data.otherCount;
            setPercentage(Math.round((1 - ((data.allowableEventCount - activeCount) / data.allowableEventCount)) * 100, 0) + "%");
            setActiveEvents(activeCount);
            setActiveDemos(data.demoCount);
            setIsExpired(data.isExpired);
            setDemoPercentage(Math.round((1 - ((data.allowableDemoCount - data.demoCount) / data.allowableDemoCount)) * 100, 0) + "%");

            setAllowableImageCount(data.allowableImageCount);
            setImageCount(data.imageCount);
            setImagePercentage(Math.round((1 - ((data.allowableImageCount - data.imageCount) / data.allowableImageCount)) * 100, 0) + "%");

            setAllowableVideoCount(data.allowableVideoCount);       
            setVideoCount(data.videoCount);
            setVideoPercentage(Math.round((1 - ((data.allowableVideoCount - data.videoCount) / data.allowableVideoCount)) * 100, 0) + "%");     
        }
    }, [data])


    return (

        <div className="d-flex align-items-center justify-content-center flex-wrap">
            <div className="w-100 justify-content-center">
                <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="main-card card">
                        <div className="d-flex flex-wrap flex-column gap-2 justify-content-center">
                            <div className="d-flex ">
                                <img src="/images/card-advance-sale.png" height="65px" />
                                <div className="d-flex justify-content-start align-items-start flex-column gap-0 m-1 ">
                                    <strong>
                                        <div className={"dashboard-card-subheading " + (isExpired ? "text-danger" : "text-success")}>
                                            {isExpired ? "Expired" : "Active"}
                                        </div>
                                    </strong>
                                    <span className="fs-15 m-0" style={{ textTransform: "capitalize" }}>{packageName}</span>
                                    <div>
                                        <small className="mt-3">Valid Till: {expiryOn}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="py-2 flex-grow-1">
                                <div>
                                    <small><strong>Invitations</strong></small>
                                    <div className="progress progress-md mt-1 progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow={percentage} aria-valuemin="0" aria-valuemax="100" style={{ width: percentage }}></div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-1 ">
                                        <small>{activeEvents}</small><small>{allowableEventCount}</small>
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <small><strong>Demos</strong></small>
                                    <div className="progress progress-md mt-1 progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow={demoPercentage} aria-valuemin="0" aria-valuemax="100" style={{ width: demoPercentage }}></div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-1 ">
                                        <small>{activeDemos}</small><small>{allowableDemoCount}</small>
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <small><strong>Image Count</strong></small>
                                    <div className="progress progress-md mt-1 progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow={imagePercentage} aria-valuemin="0" aria-valuemax="100" style={{ width: imagePercentage }}></div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-1 ">
                                        <small>{imageCount}</small><small>{allowableImageCount}</small>
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <small><strong>Video Count</strong></small>
                                    <div className="progress progress-md mt-1 progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow={videoPercentage} aria-valuemin="0" aria-valuemax="100" style={{ width: videoPercentage }}></div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-1 ">
                                        <small>{videoCount}</small><small>{allowableVideoCount}</small>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}